import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useDestinationList(){
    
    const { t } = useI18nUtils();
    const tableColumns = [
        { key: 'name', label: 'destination', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false },
    ]
    const toast = useToast()
    const isDestinationFormSidebarActive = ref(false)
    const destinationData = ref(null)
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const currentPage = ref(1)
    const perPage = ref(10)
    const refDestinationTable = ref(null)
    const destinations = ref([])
    const totalDestination = ref(0)
    const statusFilter = ref(null)
    const dataMeta = computed(() => {
        const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
        const to = Math.min(
            totalDestination.value,
          perPage.value * currentPage.value
        );
        return {
          from,
          to,
          of: totalDestination.value,
        }
    })

    const refetchData = () => {
        fetchData()
    }

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchData()
    })

    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);

        store
            .dispatch('app-sites/getDestinations', {
                limit: perPage.value,
                offset: offset,
                keywords: searchQuery.value
            })
            .then(response => {
                destinations.value  = response.data.data
                totalDestination.value = response.data.total
            })
            .catch((error) => {
                toast({
                component: ToastificationContent,
                props: {
                    title: "Error fetching Type' list",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
                })
            }
        )
    }

    const updateDestination = (data)=>{
        destinationData.value = null

        if(data){
            destinationData.value = data
        }
        
        isDestinationFormSidebarActive.value = true;
    }

    const resolveStatusVariant = (status) => {
        if (status ) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveStatusnameVariant = (status) => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const deleteData = (id) => {
        store.dispatch('app-sites/deleteDestination', id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })

            fetchData();
            }).catch(()=>{
                toast({
                    component: ToastificationContent,
                    props: {
                    title: "Error Delete Destination",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                    },
                })
            }
        )
    }

    return {
        isDestinationFormSidebarActive,
        destinationData,
        refDestinationTable,
        destinationData,
        tableColumns,
        perPage,
        totalDestination,
        currentPage,
        searchQuery,
        sortBy,
        isSortDirDesc,
        dataMeta,
        refetchData,
        fetchData,
        updateDestination,
        deleteData,
        destinations,
        t,
        statusFilter,
        resolveStatusVariant,
        resolveStatusnameVariant,
    }
}